module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_03-92668e3aa56b3b986e6363fc0f68c7fe.png";